import React, { useEffect, useState } from "react";

function AdminDashboard() {
    const [stats, setStats] = useState({
        koncerti: 0,
        novice: 0,
        abonent: 0,
        rezervacije: 0,
        vseVstopnice: 0
    });

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [koncertiRes, noviceRes, rezervacijeRes, abonentRes] = await Promise.all([
                    fetch(`${process.env.REACT_APP_BACKEND_URL}/koncerti`),
                    fetch(`${process.env.REACT_APP_BACKEND_URL}/novice`),
                    fetch(`${process.env.REACT_APP_BACKEND_URL}/rezervacije`),
                    fetch(`${process.env.REACT_APP_BACKEND_URL}/abonent`)
                ]);

                const koncertiData = await koncertiRes.json();
                const noviceData = await noviceRes.json();
                const rezervacijeData = await rezervacijeRes.json();
                const abonentData = await abonentRes.json();


                const skupnoVstopnic = Array.isArray(rezervacijeData)
                    ? rezervacijeData.reduce((sum, r) => sum + (r.steviloVstopnic || 0), 0)
                    : 0;

                setStats({
                    koncerti: Array.isArray(koncertiData) ? koncertiData.length : 0,
                    novice: Array.isArray(noviceData) ? noviceData.length : 0,
                    rezervacije: Array.isArray(rezervacijeData) ? rezervacijeData.length : 0,
                    abonent: Array.isArray(abonentData) ? abonentData.length : 0,
                    vseVstopnice: skupnoVstopnic
                });

            } catch (err) {
                console.error("Napaka pri nalaganju statistik:", err);
            }
        };

        fetchData();
    }, []);

    return (
        <div className="dashboard">
            <h1>Pregled (vseh skupaj)</h1>

            <div className="dashboard-grid">
                <div className="card">
                    <h2>{stats.koncerti}</h2>
                    <p>Koncertov</p>
                </div>

                <div className="card">
                    <h2>{stats.novice}</h2>
                    <p>Novic</p>
                </div>

                <div className="card">
                    <h2>{stats.vseVstopnice}</h2>
                    <p>Rezervacij</p>
                </div>

                <div className="card">
                    <h2>{stats.abonent}</h2>
                    <p>abonentov</p>
                </div>
            </div>
        </div>
    );
}

export default AdminDashboard;